import React, { useRef, useContext } from 'react'
import { Grid, Box, Card, Tooltip } from '@material-ui/core'
import { components } from 'cng-web-lib'
import { useFormContext, useWatch } from "react-hook-form";
import { A6ATranslationContext } from '../contexts/A6ATranslationContext'
import CngSection from 'src/components/cngcomponents/CngSection'
import A6aPreviousFormProperties from '../A6aPreviousFormProperties'

const { button: { CngIconButton } } = components

const { initialValues } = A6aPreviousFormProperties.formikProps

function A6APreviousCCNSection() {
    const { setValue, getValues } = useFormContext();
    const { getTranslatedText } = useContext(A6ATranslationContext)

    const a6aPrevious = useWatch({ name: 'a6aPrevious' })
    const lastIndex = useRef(a6aPrevious.length - 1)

    function handleAddPreviousCCN(data) {
        const a6aPrevious = [...getValues('a6aPrevious'), { ...data, _id: ++lastIndex.current }]
        setValue('a6aPrevious', a6aPrevious)
    }

    function handleDeletePreviousCCN(data) {
        const a6aPrevious = [...getValues('a6aPrevious')].filter((previous) =>
            previous.id ? previous.id !== data.id : previous._id !== data._id
        )

        setValue('a6aPrevious', a6aPrevious)
    }


    return (
        <Grid item xs={12}>
            <CngSection title={getTranslatedText('A6A', 'a6aPrevious')} alignItems='flex-end'>
                <Grid container spacing={1}>
                    {a6aPrevious.map((previous, index) => (
                        <Grid key={index} item xs={12}>
                            <Card variant='outlined'>
                                <Box padding={2}>
                                    <Grid container justify='space-between' spacing={1}>

                                        <Grid item xs={10}>
                                            <A6aPreviousFormProperties.Fields index={index} />
                                        </Grid>

                                        <Grid item xs='auto'>
                                            <Grid container spacing={1}>
                                                <Grid item>
                                                    <Tooltip placement='bottom' title='Clone'>
                                                        <span>
                                                            <CngIconButton
                                                                icon={['fal', 'copy']} size='small' type='outlined'
                                                                onClick={() => handleAddPreviousCCN({ ...previous, id: undefined })}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </Grid>

                                                <Grid item>
                                                    <Tooltip placement='bottom' title='Delete'>
                                                        <span>
                                                            <CngIconButton
                                                                icon={['fal', 'trash']} size='small' type='outlined'
                                                                onClick={() => handleDeletePreviousCCN(previous)}
                                                            />
                                                        </span>
                                                    </Tooltip>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </Card>
                        </Grid>
                    ))}

                    <Grid item xs={12}>
                        <Grid container spacing={1}>
                            <Grid item xs='auto'>
                                <Tooltip placement='bottom' title='Add new'>
                                    <span>
                                        <CngIconButton
                                            icon={['fal', 'plus']}
                                            onClick={() => handleAddPreviousCCN(initialValues)}
                                            size='small'
                                            type='outlined'
                                        />
                                    </span>
                                </Tooltip>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </CngSection>
        </Grid>
    )
}

export default A6APreviousCCNSection